<template>
  <ul class="collapsible popout">
    <li class="collapsible-margin">
      <div class="collapsible-header">
        <i class="material-icons">shuffle</i> Reshuffling Your Draw Deck
        <i class="material-icons">expand_more</i>
      </div>
      <div class="collapsible-body tech row">
        <div class="col s12">
          If your draw deck is empty and you need to draw a card, first check
          your state card: If your state card shows a barbarian symbol: 
          <br /><br />1. If there are no exhaust tokens
          on your nation deck and you have one or more exhaust tokens on your state
          card, place the top card of your nation deck in your discard pile.
          Then move an exhaust token from your state card to your nation deck. If there
          is already an exhaust token on your nation deck, or if you have none on your
          state card, skip this step. If you place your ascension card in your discard
          pile, immediately flip your state card to its empire side. 
          <br /><br />2. Shuffle your
          discard pile into a new draw deck. 
          <br /><br />3. Keep drawing cards as normal. 
          <br /><br />If
          you’re playing as the Arthurians, the ascension card is your nadir card. Instead
          of placing it in your discard pile, immediately place it in your play
          area. Do not flip your state card. 
          <br /><br />If you’re playing as the Vikings,
          the card is your zenith card. When you place it in your discard pile,
          it will trigger the end of the game! Do not flip your state card. If
          you’re playing as the Utopians, you have no nation deck so you must
          skip step 1. 
          <br /><br />If your state card shows an empire symbol: 
          <br /><br />1. If there are no tokens in
          your development area and you have one or more tokens on your state
          card, you may pay the development cost shown on one of your
          development cards to develop it. Place that card in your discard pile.
          Then move an token from your state card into your development area. If
          there is already an token in your development area, or you have none
          on your state card, skip this step. 
          <br /><br />If you are playing as the
          Utopians, you have no development area so you must skip step 1. 
          <br /><br />2.
          Shuffle your discard pile into a new draw deck. 
          <br /><br />3. Keep drawing cards
          as normal. Resolve this immediately when triggered, even on another
          player’s turn. Some cards state ‘draw the top card of the deck if
          able’. 
          <br /><br />If your draw deck is empty, do not draw a card and do not
          reshuffle your deck.
        </div>
      </div>
    </li>
    <li class="collapsible-margin active">
      <div class="collapsible-header">
        <i class="material-icons">cleaning_services</i> Player Cleanup
      </div>
      <div class="collapsible-body tech row">
        <div class="col s12">
          <ul>
            <li>
              First, add 1 from the supply to any card in the market.
            </li>
            <li>
              Next, remove all action and exhaust tokens from your state card and from all of
              the following: all cards in your play area, your nation deck, all
              cards in your development area and your power card.
            </li>
            <li>
              Then place 3 action tokens and 5 exhaust tokens on your state card.
            </li>
          </ul>
          <ul>
            <li>
              Next, you may discard any number of cards from your hand into your
              discard pile
            </li>
            <li>
              Finally, draw cards from your draw deck up to your hand size of
              five. If you already hold cards equal to or exceeding your hand
              size, don’t draw any cards. Some card effects might increase your
              hand size.
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  setup() {
    onMounted(() => {
      var elems = document.querySelectorAll(".collapsible");
      window.M.Collapsible.init(elems, {});
    });
  },
});
</script>

<style></style>
